import { render, staticRenderFns } from "./EscortPrice.vue?vue&type=template&id=284214e7&"
import script from "./EscortPrice.vue?vue&type=script&lang=js&"
export * from "./EscortPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports